export const REDUCED_ANALYTICS_ENABLED = true;

const retainedEvents = new Set([
  "subscription_started",
  "ink_pack_purchased",
  "user_signed_up",
  "$exception",
  "$identify",
  "$create_alias",
  "$set",
  "$set_once",
  "$groupidentify",
  // Browser session recording sends snapshots through before_send too.
  "$snapshot",
]);

export function filterAnalyticsEvent<T extends { event: string }>(
  event: T | null,
  reducedAnalyticsEnabled: boolean = REDUCED_ANALYTICS_ENABLED,
): T | null {
  if (
    !event ||
    !reducedAnalyticsEnabled ||
    retainedEvents.has(event.event) ||
    event.event.startsWith("onboarding_")
  ) {
    return event;
  }

  return null;
}
